//import queryString from 'query-string';
import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';


export const getParametros = async () => {
  try {
      const userInfo = fetchUser();

      const {data}  = await Axios.get(
        `/params?empresa=${userInfo.empresa}`
      );
      return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getParametrosId = async (idCliente) => {
    try {
        const userInfo = fetchUser();
  
        const {data}  = await Axios.get(
          `/params/cliente?empresa=${userInfo.empresa}&cliente=${idCliente}`
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
    };

  export const crearParametro = async (param) => {
    try {
      const userInfo = fetchUser();
      param.empresa = userInfo.empresa;

      const {data}  = await Axios.post(
        '/params', param
      );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateParametro = async (param) => {
    try {
        const userInfo = fetchUser();
        param.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/params/${param._id}`, param
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteParametro = (Id) => Axios.delete(`/parametros/${Id}`);



export const getCategorias = async () => {
  try {
      const {data}  = await Axios.get(
        '/categorias'
      );
      return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const getSubCategorias = async () => {
    try {
        const {data}  = await Axios.get(
          '/subcategorias'
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
    };